<h1 class="polity-content">
    <h1 class="polity-title" [innerHTML]="data.title"></h1>
    <div class="polity-description" [innerHTML]="data.description"> </div>
</h1>
